// Import utils
import { getPathPosition } from "../core/utilities";

// Import controllers to use
import SearchPanelController from "../controllers/SearchPanelController";
import EventCalendarListController from "../controllers/EventCalendarListController";
import IntroTextController from "../controllers/IntroTextController";
import AnnouncementsController from "../controllers/AnnouncementsController";
import QuickLinksController from "../controllers/QuickLinksController";
import TipsController from "../controllers/TipsController";

// Global components not included on any other component
import "../components/loader/index";
import YouTubeVideoPanelController from "../controllers/YouTubeVideoPanelController";
import TwitterPanel from "../controllers/TwitterPanel";
import { VanillaPagesType } from "../core/types/VanillaPages";
import EventModel from "../models/EventModel";
import TestimonialPanelController from "../controllers/TestimonialPanelController";
import UpcomingEventListController from "../controllers/UpcomingEventsListController";

const remove_empty_message = async () => {
  // only when we're in events category page
  if (await EventModel.isEventsCategoryPage()) {
    const el = document.querySelector("section.pageBox div.Empty");
    if (el) {
      el.remove();
    }
  }
};

/**
 * Initializes search panel component.
 */
const search_load = async (): Promise<void> => {
  const searchPanel: SearchPanelController = new SearchPanelController(
    "#SearchPanel"
  );
  searchPanel.init();
};

const intro_text_load = (categoriesName: string) => {
  /** INTRO TEXT FRAGMENT */
  // Create Intro text model
  const introTextMdl: IntroTextController = new IntroTextController();
  introTextMdl.init(VanillaPagesType.discussions, {
    anchor: "#CCCHtmlPanel",
    catName: categoriesName,
  });
  /** END INTRO TEXT FRAGMENT */
};

const quick_links_load = async (categoriesName: string) => {
  /** QUICK LINKS FRAGMENT */
  // Create quicklinks model
  const qlinks: QuickLinksController = new QuickLinksController();
  qlinks.init(VanillaPagesType.discussions, {
    anchor: "#CCCQuickLinks",
    catName: categoriesName,
  });
  return true;
  /** END QUICK LINKS FRAGMENT */
};

const announcements_load = (categoriesName: string) => {
  const announcementPanels = new AnnouncementsController();
  announcementPanels.init(VanillaPagesType.discussions, {
    anchor: "#CCCAnnouncements",
    catName: categoriesName,
  });
};

const upcoming_events_load = (categoriesName: string) => {
  const upcomingEventsPanel = new UpcomingEventListController();
  upcomingEventsPanel.init(VanillaPagesType.discussions, categoriesName);
};

const tips_load = async () => {
  /** TIPS FRAGMENT */
  // Create Tips model
  const tipsCtrl: TipsController = new TipsController();
  tipsCtrl.init("#Tips");
  return true;
  /** END TIPS FRAGMENT */
};

const events_load = async () => {
  const events = new EventCalendarListController(
    "#EventCalendar",
    "#EventList",
    "#EventsPanel"
  );
  events.init();
};

const eventReplayListLoad = () => {
  console.log("%c\neventReplayListLoad", "color: red");
};

const youtube_panel_load = async (categoriesName: string) => {
  // Create youtibevideopanel model
  const yvideo: YouTubeVideoPanelController = new YouTubeVideoPanelController();
  yvideo.init("#CCCYoutubeVideo", categoriesName);
};

const twitter_panel_load = async (categoriesName: string) => {
  const tpanels = new TwitterPanel();
  tpanels.init(
    "#TwitterPanels",
    process.env.DATA_URL + `twitter-accounts/${categoriesName}.txt`
  );
};

const testimonial_panel_load = (categoryName: string) => {
  const tp = new TestimonialPanelController();
  tp.init(VanillaPagesType.discussions, "#CCCTestimonialQuote", categoryName);
};

// recipe
const discussions_recipe = () => {
  // selecting main content div
  //const mainContent: HTMLElement = document.querySelector(".MainContent");
  console.info("Discussions recipe");
  remove_empty_message();

  // gets url position 3 (category slug name) since we'll use it to load the jsonp file
  const categoriesName = getPathPosition(3);

  search_load();
  intro_text_load(categoriesName);
  quick_links_load(categoriesName);
  announcements_load(categoriesName);
  tips_load();
  events_load();
  eventReplayListLoad();
  youtube_panel_load(categoriesName);
  twitter_panel_load(categoriesName);
  testimonial_panel_load(categoriesName);
  upcoming_events_load(categoriesName);
};

discussions_recipe();
